import { render, staticRenderFns } from "./serviceCard.vue?vue&type=template&id=4c3ee620&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./serviceCard.vue?vue&type=style&index=0&id=4c3ee620&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ee620",
  null
  
)

export default component.exports